/**
 * Display name from student profile only (Supabase display_name).
 * @param {{ displayName?: string } | null | undefined} profile
 */
export function getLearnerDisplayName(profile) {
  return profile?.displayName?.trim() || '';
}

/**
 * Profile display name with email fallback for nav and greetings.
 * @param {{ displayName?: string } | null | undefined} profile
 * @param {{ email?: string } | null | undefined} [platformUser]
 */
export function resolveLearnerDisplayName(profile, platformUser) {
  return getLearnerDisplayName(profile) || platformUser?.email?.split('@')[0] || '';
}

/**
 * @param {string} displayName
 * @param {boolean} [showEnglish]
 */
export function formatLearnerGreeting(displayName, showEnglish = true) {
  const name = displayName?.trim() || '';
  if (showEnglish) return name ? `Welcome, ${name}` : 'Welcome';
  return name ? `नमस्ते, ${name}` : 'नमस्ते';
}
